// ============================================================================
// SATU SUMBER warna status BERSAMA (UAT-FIX-4 (3) Sistem Warna).
// "Warna = MAKNA": abu=belum jalan · AMBER=perlu tindakan · biru=sedang berjalan ·
// hijau=selesai · merah=ditolak/batal. JANGAN definisikan ulang per halaman —
// WO & Permintaan (mis.) HARUS memakai warna sama untuk status yang bermakna sama.
//
// Keputusan penting: "Selesai Produksi" (WO) = AMBER (perlu tindakan), karena Admin
// Produksi masih harus "Kirim ke Gudang" — supaya tugas tidak terlewat.
// Kategori barang: JUAL=hijau, MoU=amber (sama dengan badge di label QR fisik).
// ============================================================================
import React from "react";
import { Badge } from "@/components/ui/badge";

// semantic -> badge variant (variants ada di components/ui/badge.jsx: latar tipis + teks gelap)
const SEMANTIC = {
  // ---- ABU: belum jalan ----
  Draft: "neutral", DRAFT: "neutral", OPEN: "neutral", SUPERSEDED: "neutral",
  // ---- AMBER: perlu tindakan ----
  Diajukan: "warning", PENDING_APPROVAL: "warning", REQUESTED: "warning",
  "Menunggu Produksi": "warning", MENUNGGU_PRODUKSI: "warning",
  "Selesai Produksi": "warning",            // masih harus "Kirim ke Gudang"
  READY_TO_SHIP: "warning", VERIFIED: "warning",
  "Perlu Transfer": "warning",
  // ---- BIRU: sedang berjalan ----
  Disetujui: "info", APPROVED: "info",
  "Dikirim ke Gudang": "info", Dikirim: "info", SHIPPED: "info",
  DISPATCHED: "info", Dikeluarkan: "info", PREPARING: "info", COUNTING: "info",
  PARTIALLY_RECEIVED: "info", "Diterima Sebagian": "info", ACTIVE: "info",
  // ---- HIJAU: selesai ----
  Diterima: "success", RECEIVED: "success", Terposting: "success", TERPOSTING: "success",
  POSTED: "success", Lunas: "success", LUNAS: "success", Selesai: "success",
  COMPLETED: "success", CLOSED: "success", Ditutup: "success",
  // ---- MERAH: ditolak / batal ----
  Ditolak: "danger", REJECTED: "danger", Dibatalkan: "danger", CANCELLED: "danger",
};

// label tampilan (enum -> Indonesia). Status WO sudah berbahasa Indonesia (label = dirinya).
const LABEL = {
  DRAFT: "Draft", PENDING_APPROVAL: "Menunggu Persetujuan", APPROVED: "Disetujui",
  MENUNGGU_PRODUKSI: "Menunggu Produksi", READY_TO_SHIP: "Siap Dikirim",
  REJECTED: "Ditolak", CANCELLED: "Dibatalkan", CLOSED: "Selesai",
  REQUESTED: "Diajukan", PREPARING: "Disiapkan", DISPATCHED: "Dikeluarkan",
  COMPLETED: "Selesai", SHIPPED: "Dikirim", RECEIVED: "Diterima",
  PARTIALLY_RECEIVED: "Diterima Sebagian", OPEN: "Dibuka", COUNTING: "Sedang Dihitung",
  POSTED: "Terposting", VERIFIED: "Terverifikasi", ACTIVE: "Aktif", SUPERSEDED: "Digantikan",
};

export function statusVariant(status) {
  if (status == null) return "neutral";
  return SEMANTIC[status] || SEMANTIC[String(status).toUpperCase()] || "neutral";
}

export function statusLabel(status) {
  if (status == null) return "-";
  return LABEL[status] || status;
}

// Badge status seragam. Warna murni dari MAKNA; teks status tetap tampil (aksesibilitas buta warna).
export const StatusBadge = ({ status, label, testid, className }) => (
  <Badge variant={statusVariant(status)} className={className} data-testid={testid}>
    {label || statusLabel(status)}
  </Badge>
);

// Kategori barang — sama dengan label QR fisik: JUAL hijau, MoU amber.
// RETUR PASCA-UAT: CACAT merah = barang cacat (menunggu/proses retur), BUKAN stok jual/MoU.
export const CategoryBadge = ({ cat, testid, className }) => {
  const isMou = cat === "MoU" || cat === "MOU";
  const isJual = cat === "Jual" || cat === "JUAL";
  const isCacat = cat === "CACAT" || cat === "Cacat";
  if (!isMou && !isJual && !isCacat) return <span className="text-muted-foreground">-</span>;
  return (
    <Badge variant={isCacat ? "destructive" : isMou ? "warning" : "success"} className={className} data-testid={testid}>
      {isCacat ? "CACAT" : isMou ? "MoU" : "JUAL"}
    </Badge>
  );
};
